import { render, staticRenderFns } from "./bank.vue?vue&type=template&id=27de28d6&scoped=true"
import script from "./bank.vue?vue&type=script&lang=js"
export * from "./bank.vue?vue&type=script&lang=js"
import style0 from "./bank.vue?vue&type=style&index=0&id=27de28d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27de28d6",
  null
  
)

export default component.exports